// Generated by scripts/theme-config/theme-config.js from api::theme-configuration. Do not edit.

/**
 * Beneficios preset elegido por el tenant. `legacy` reproduce el look
 * histórico (features planos: icono + texto, sin tarjeta). `card` sigue
 * el Figma de HoM (cada beneficio en tarjeta blanca con sombra, contenido
 * centrado, y la cabecera de sección alineada a la izquierda).
 */
export type GeneratedBeneficiosStyle = 'legacy' | 'card';

export const generatedBeneficiosStyle: GeneratedBeneficiosStyle = 'legacy';
